import { EventName } from '@lit/react';
import { BlocksInputField } from 'blocks-nextjs/blocks-web-components/components/input-field/input-field';
import { BlocksChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';

export const CatInputField = createComponent({
  react: React,
  tagName: 'cat-input-field',
  elementClass: BlocksInputField,
  events: {
    onBlChange: 'bl-change' as EventName<BlocksChangeEvent>
  }
});
